export function UlComponent($timeout) {
  const closeEl = el => {
    if (el && el[0] && el[0].clientHeight) el.parent().click();
  };

  const updateEl = (el, container) => {
    if (!el || !el[0] || !el.parent() || !el.parent()[0]) return;
    closeEl(null, el);
    // if (el[0].clientHeight) el.parent().click();
    if (!el.parent()[0]) return;
    const rect = el.parent()[0].getClientRects()[0];
    if (!rect) return;
    const left = el.hasClass('pull-right') ?
      rect.left - el.width() + rect.width - 2 : rect.left;
    let top = rect.bottom + 3;

    if (rect.top >= el.height() && container && container[0] && (top + el.height() - container.position().top - 70 > container.height())) {
      top = rect.top - el.height() - 10;
    }
    el.css({
      top: top,
      left: left
    });
  };

  return {
    link: function(scope, el) {
      el[0].addEventListener('mouseleave', closeEl.bind(this, el), false);

      let container = el.closest('.aggregate-container');
      if (!container[0]) container = el.closest('table');
      let btn;
      $timeout(() => {
        const elParent = el.parent();
        btn = elParent.find('.dropdown-toggle');
        if (!btn[0]) btn = elParent.find('> i');
        if (!btn[0]) btn = elParent.find('[data-toggle]');
        if (btn[0]) {
          btn[0].addEventListener('click', updateEl.bind(this, el, container), false);
        } else {
          console.error(elParent);
        }
        $timeout(() => {
          updateEl(el, container);
        }, 100);
      }, 100);

      el.on('$destroy', function() {
        try {
          el[0].removeEventListener('mouseleave', closeEl);
          if (btn[0]) btn[0].removeEventListener('click', updateEl);
        } catch (err) {
          //
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/shared/ul.component.js